<div id="campo"
  [ngClass]="this.TipoPantalla=='LISTADO' ? 'campo campo-sm' : '' "
  [ngClass]="this.TipoPantalla==='REPORTE' ? 'report__filters ' : '' "
  *ngIf="this.form_template">

  <!-- BEGIN MODAL -->
  <ng-template #contenido let-modal>
    <div class="modal-header">
      <h4 class="modal-title"></h4>
      <button type="button" class="btn-close btn-rounded" data-bs-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <app-advancedtable [WsURL]=strWsURLModal [WsFiltroModal]=WsFiltroModal (RetornoModal)=RetornoModal($event) [mostrarModal]=true>
      </app-advancedtable>
    </div>
  </ng-template>
  <!-- END MODAL -->
  <div *ngIf="Mostrartitulofiltro == false">
    <div id="buttons" *ngIf="this.ToolbarMS">
      <!-- BEGIN Toolbar -->
      <div class="row">
        <div class="col-12">
          <div class="navbar-header toolbar">
            <div class="d-flex"></div>
            <div class="d-flex">
              <div class="d-inline-block bloque" *ngFor="let boton of this.ToolbarMS">
                <button type="button" title="{{boton.Tooltip}}" Style="margin-left: 10px" id="{{boton.Evento}}"
                  name="{{boton.Evento}}" (click)="EventoClickMS($event, boton.URL, boton.Evento)"
                  class="btn blanco  btn-label waves-light" [ngStyle]="{'background-color': boton.class }">
                  <i class="fas {{boton.icono}} label-icon" style="pointer-events:none ;"></i>
                  {{boton.boton}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END Toolbar -->

  <!-- BEGIN FORMULARIO -->

  <form [formGroup]="this.myFormGroup" (submit)="ValidarFormulario()">

    <ng-container *ngIf="form_template.length > 0 && this.FiltrosAvan != 1">
      <div class="row">

        <ng-container *ngFor="let form_elem of form_template[0].FiltrosExpuestos;let indice = index">

          <ng-container [ngSwitch]="form_elem.type">
            <ng-container *ngSwitchCase="'textbox_modal'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="filtro_{{this.FormID}}{{form_elem.label}}" (click)="AbrirModal(contenido, form_elem)">
                    {{form_elem.title}}>
                  </label>
                  <input type="text" class="form-control" id="filtro_{{this.FormID}}{{form_elem.label}}"
                     name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                    formControlName="{{form_elem.label}}">
                    <div *ngIf="form_elem.validators">
                      <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                        {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                        </div>
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                          {{form_elem.validators.msg_validacion}}
                        </div>
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                          {{form_elem.title}} debe tener al menos  1 caracter..
                        </div>
                      </span>
                    </div>
                </div>
              </div>
            </ng-container>


            <ng-container *ngSwitchCase="'textbox'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="filtro_{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <input type="text" id="filtro_{{this.FormID}}{{form_elem.label}}" 
                    name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                    (change)="Select_ocultar(form_elem, $event)"
                    [readonly]="form_elem.disabled=='S'" formControlName="{{form_elem.label}}" class="form-control">
                    <div *ngIf="form_elem.validators">
                      <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                        {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                        </div>
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                          {{form_elem.validators.msg_validacion}}
                        </div>
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                          {{form_elem.title}} debe tener al menos  1 caracter..
                        </div>
                      </span>
                    </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'textbox_date'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <input type="date" id="filtro_{{this.FormID}}{{form_elem.label}}" 
                    name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                    (change)="Select_ocultar(form_elem)"
                    [readonly]="form_elem.disabled=='S'" formControlName="{{form_elem.label}}" class="form-control">
                    <div *ngIf="form_elem.validators.required">
                      <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                        {{form_elem.validators.msg_validacion}}
                      </span>
                    </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'number'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <input type="text" id="filtro_{{this.FormID}}{{form_elem.label}}" 
                  (change)="Select_ocultar(form_elem, $event)" [allowNegativeNumbers]="true" mask="separator.2"
                    thousandSeparator="," name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                    [readonly]="form_elem.disabled=='S'" formControlName="{{form_elem.label}}" class="form-control">
                </div>
              </div>
            </ng-container>


            <ng-container *ngSwitchCase="'select_url'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{form_elem.label}}" class=" 'col-form-label'" (click)="AbrirModal(contenido, form_elem)"
                    style="text-decoration: underline">
                    {{form_elem.title}}
                    <span *ngIf="form_elem.validators.required">(*)</span>
                  </label>

                  <input type="text" class="form-control" 
                    id="filtro_{{this.FormID}}{{form_elem.label}}" name="{{form_elem.label}}"
                    placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}"
                    [readonly]="form_elem.disabled=='S'">
                  <div *ngIf="form_elem.validators.required">
                    <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                      {{form_elem.validators.msg_validacion}}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>


            <ng-container *ngSwitchCase="'select'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <ng-select formControlName="{{form_elem.label}}" id="filtro_{{this.FormID}}{{form_elem.label}}"
                    (change)="CboClick(form_elem)"
                    [readonly]="form_elem.disabled=='S'" [items]="form_elem.options" bindLabel="text" bindValue="value">
                  </ng-select>
                  <div *ngIf="form_elem.validators.required">
                    <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                      {{form_elem.validators.msg_validacion}}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'select_multiple'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <ng-select formControlName="{{form_elem.label}}" id="{{this.FormID}}{{form_elem.label}}"
                    [(ngModel)]="this.ngmodels[form_elem.label]" [readonly]="form_elem.disabled=='S'"
                    [items]="form_elem.options" bindLabel="text" bindValue="value" multiple="true"
                    labelForId="{{form_elem.label}}">
                  </ng-select>
                  <div *ngIf="form_elem.validators.required">
                    <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                      {{form_elem.validators.msg_validacion}}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'textarea'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <textarea name="{{form_elem.name}}" class="form-control"
                    id="filtro_{{this.FormID}}{{form_elem.label}}" 
                    placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}">
                  </textarea>
                  <div *ngIf="form_elem.validators">
                    <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                      <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                        {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                      </div>
                      <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                        {{form_elem.validators.msg_validacion}}
                      </div>
                      <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                        {{form_elem.title}} debe tener al menos  1 caracter..
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'checkbox'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label class="form-check-label" for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <div class="form-check form-switch form-switch-md">
                    <input type="checkbox" id="filtro_{{this.FormID}}{{form_elem.label}}" class="form-check-input"
                    (change)="Select_ocultar(form_elem, $event)"
                      placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}">
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'hidden'">
              <input type="hidden" class="form-control" id="filtro_{{this.FormID}}{{form_elem.label}}"
                name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                formControlName="{{form_elem.label}}">
            </ng-container>

            <ng-container *ngSwitchCase="'textbox_time'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <input type="time" id="filtro_{{this.FormID}}{{form_elem.label}}" 
                    name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                    (change)="Select_ocultar(form_elem)"
                    [readonly]="form_elem.disabled=='S'" formControlName="{{form_elem.label}}" class="form-control">
                    <div *ngIf="form_elem.validators.required">
                      <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                        {{form_elem.validators.msg_validacion}}
                      </span>
                    </div>
                </div>
              </div>
            </ng-container>

          </ng-container>
        </ng-container>
      </div>

    </ng-container>

    <ng-container *ngIf="form_template.length > 0  || this.FiltrosAvan == 1">

      <div class="row" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" [ngClass]="{'mostrarAvanzados': FiltrosAvan}">

        <ng-container *ngFor="let form_elem of form_template[0].FiltrosAvanzado;let indice = index">

          <ng-container [ngSwitch]="form_elem.type">
            <ng-container *ngSwitchCase="'textbox_modal'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}" (click)="AbrirModal(contenido, form_elem)">
                    {{form_elem.title}}>
                  </label>
                  <input type="text" class="form-control" id="filtro_{{this.FormID}}{{form_elem.label}}"
                    name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                    (change)="CboClick(form_elem)"
                    formControlName="{{form_elem.label}}">
                    <div *ngIf="form_elem.validators">
                      <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                        {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                        </div>
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                          {{form_elem.validators.msg_validacion}}
                        </div>
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                          {{form_elem.title}} debe tener al menos  1 caracter..
                        </div>
                      </span>
                    </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'textbox'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="filtro_{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <input type="text" id="filtro_{{this.FormID}}{{form_elem.label}}" name="{{form_elem.label}}"
                    placeholder="{{form_elem.placeholder}}" [readonly]="form_elem.disabled=='S'"
                    (change)="Select_ocultar(form_elem, $event)"
                    formControlName="{{form_elem.label}}" class="form-control">
                    <div *ngIf="form_elem.validators">
                      <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                        {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                        </div>
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                          {{form_elem.validators.msg_validacion}}
                        </div>
                        <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                          {{form_elem.title}} debe tener al menos  1 caracter..
                        </div>
                      </span>
                    </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'textbox_date'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <input type="date" id="filtro_{{this.FormID}}{{form_elem.label}}" name="{{form_elem.label}}"
                    placeholder="{{form_elem.placeholder}}" [readonly]="form_elem.disabled=='S'"
                    (change)="Select_ocultar(form_elem)"
                    formControlName="{{form_elem.label}}" class="form-control">
                    <div *ngIf="form_elem.validators.required">
                      <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                        {{form_elem.validators.msg_validacion}}
                      </span>
                    </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'number'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <input type="text" id="filtro_{{this.FormID}}{{form_elem.label}}" name="{{form_elem.label}}"
                  (change)="Select_ocultar(form_elem, $event)" [allowNegativeNumbers]="true" mask="separator.2"
                    thousandSeparator="," placeholder="{{form_elem.placeholder}}" [readonly]="form_elem.disabled=='S'"
                    formControlName="{{form_elem.label}}" class="form-control">
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'select_url'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{form_elem.label}}" class=" 'col-form-label'" (click)="AbrirModal(contenido, form_elem)"
                    style="text-decoration: underline">
                    {{form_elem.title}}
                    <span *ngIf="form_elem.validators.required">(*)</span>
                  </label>

                  <input type="text" class="form-control" 
                    id="filtro_{{this.FormID}}{{form_elem.label}}" name="{{form_elem.label}}"
                    placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}"
                    (change)="Select_ocultar(form_elem)"
                    [readonly]="form_elem.disabled=='S'">
                  <div *ngIf="form_elem.validators.required">
                    <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                      {{form_elem.validators.msg_validacion}}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'select'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <ng-select formControlName="{{form_elem.label}}" id="filtro_{{this.FormID}}{{form_elem.label}}"
                    (change)="CboClick(form_elem)"
                    [readonly]="form_elem.disabled=='S'" [items]="form_elem.options" bindLabel="text" bindValue="value">
                  </ng-select>
                  <div *ngIf="form_elem.validators.required">
                    <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                      {{form_elem.validators.msg_validacion}}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'textarea'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <textarea name="{{form_elem.name}}" class="form-control"
                    id="filtro_{{this.FormID}}{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                    formControlName="{{form_elem.label}}">
                </textarea>
                <div *ngIf="form_elem.validators">
                  <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['maxlength'] ">
                      {{form_elem.title}} No puede tener mas de {{form_elem.A03LON}} caracteres..
                    </div>
                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['required']">
                      {{form_elem.validators.msg_validacion}}
                    </div>
                    <div *ngIf="this.myFormGroup.controls[form_elem.label].errors?.['minlength']">
                      {{form_elem.title}} debe tener al menos  1 caracter..
                    </div>
                  </span>
                </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'checkbox'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label class="form-check-label" for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <div class="form-check form-switch form-switch-md">
                    <input type="checkbox" id="filtro_{{this.FormID}}{{form_elem.label}}" class="form-check-input"
                    (change)="Select_ocultar(form_elem, $event)"
                      placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}">
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'radio'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label class="form-check-label" for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <input type="radio" id="filtro_{{this.FormID}}{{form_elem.label}}" class="form-check-input"
                  (change)="Select_ocultar(form_elem, $event)"
                    placeholder="{{form_elem.placeholder}}" formControlName="{{form_elem.label}}">
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'span'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <input type="text" class="form-control" id="filtro_{{this.FormID}}{{form_elem.label}}"
                    name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                    formControlName="{{form_elem.label}}" disabled>

                  <div *ngIf="form_elem.validators.required">
                    <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                      {{form_elem.validators.msg_validacion}}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'select_multiple'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <ng-select formControlName="{{form_elem.label}}" id="{{this.FormID}}{{form_elem.label}}"
                    [(ngModel)]="form_elem.value" [readonly]="form_elem.disabled=='S'" [items]="form_elem.options"
                    bindLabel="text" multiple="true">
                  </ng-select>
                  <div *ngIf="form_elem.validators.required">
                    <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                      {{form_elem.validators.msg_validacion}}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'hidden'">
              <input type="hidden" class="form-control" id="filtro_{{this.FormID}}{{form_elem.label}}"
                name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                formControlName="{{form_elem.label}}">
            </ng-container>

            <ng-container *ngSwitchCase="'textbox_time'">
              <div [ngClass]="clasesElemento(form_elem)">
                <div class="mt-1 mb-1">
                  <label for="{{this.FormID}}{{form_elem.label}}">{{form_elem.title}}</label>
                  <input type="time" id="filtro_{{this.FormID}}{{form_elem.label}}" 
                    name="{{form_elem.label}}" placeholder="{{form_elem.placeholder}}"
                    (change)="Select_ocultar(form_elem)"
                    [readonly]="form_elem.disabled=='S'" formControlName="{{form_elem.label}}" class="form-control">
                    <div *ngIf="form_elem.validators.required">
                      <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                        {{form_elem.validators.msg_validacion}}
                      </span>
                    </div>
                </div>
              </div>
            </ng-container>

          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </form>
  <!-- END FORMULARIO -->
  <div class="row mt-4" style="align-items: end;">
    <div class="offset-md-8 col-md-4" style="text-align: right;">
      <div class="d-inline-block bloque mb-1 ms-2" *ngIf="MostrarbotonBuscar == 'true'">
        <button type='button' class="btn btn-info btn-label waves-light btn-sm" (click)="ValidarFormulario()">
          <i class="bx bx-search-alt-2 label-icon" style="pointer-events:none ;"></i> Buscar
        </button>
      </div>
      <ng-container *ngIf="form_template[0].FiltrosAvanzado.length > 0">
        <div class="d-inline-block bloque mb-1 ms-2" *ngIf="this.FiltrosAvan != 1">
          <button type="button" (click)="toggleAvanzados()"
            [ngClass]="isCollapsed ? 'btn btn-light btn-label waves-light btn-sm' : 'btn btn-secondary btn-label waves-light btn-sm'">
            <i class="fas fa-filter label-icon" style="pointer-events:none ;"></i>Avanzados
          </button>
        </div>
      </ng-container>
    </div>
  </div>


</div>
<!-- div inicial del campo -->

<div id="buttons" *ngIf="this.ToolbarMS">
  <!-- BEGIN Toolbar -->
  <div class="row">
    <div class="col-12">
      <div class="navbar-header toolbar">
        <div class="d-flex"></div>
        <div class="d-flex">
          <div class="d-inline-block bloque" *ngFor="let boton of this.ToolbarMS">
            <button type="button" title="{{boton.Tooltip}}" Style="margin-left: 10px" id="{{boton.Evento}}"
              name="{{boton.Evento}}" (click)="EventoClickMS($event, boton.URL, boton.Evento)"
              class="btn blanco  btn-label waves-light" [ngStyle]="{'background-color': boton.class }">
              <i class="fas {{boton.icono}} label-icon" style="pointer-events:none ;"></i>
              {{boton.boton}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END Toolbar -->

</div> <!-- END BUTTONS -->
<app-scroll-to-top>
</app-scroll-to-top>
